import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Progress } from '../progress.model';
import { ProgressService } from '../progress.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { sortBy, get, lowerCase, map, chain, unescape } from 'lodash';
import { AppRoutingService } from '../../app-routing.service';
import { Encoder } from '../../../utils/encoder';
import { ProgressListResponse } from '../progress-list-reponse.model';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-progress-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ProgressListComponent implements OnInit {

  alerts: any = {
    error: {
      show: false,
      type: 'danger',
      msg: 'An error occurred'
    }
  };

  showAlert: boolean;

  progressList: Array<Progress>;

  showAll: boolean = false;

  ProgressListResponse: ProgressListResponse;
  nextPageKey?: string = '';
  private previousUrl: string;

  constructor(private router: Router, private route: ActivatedRoute,
    private ProgressService: ProgressService, private routingService: AppRoutingService) {

    this.progressList = new Array<Progress>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.getProgressList();
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }

  onLoadMoreClick(): void {
    if (this.nextPageKey) {
      this.loadMoreList();
    }
  }

  loadMoreList() {
    this.ProgressService.getProgressList(this.nextPageKey)
      .subscribe((res) => {
        this.ProgressListResponse = res;
        this.ProgressListResponse.data = chain(this.ProgressListResponse.data)
          .sortBy((item) => parseInt(item.date.split('-').join(''))).reverse().value();
        this.progressList = this.progressList.concat(this.ProgressListResponse.data);
        this.nextPageKey = this.ProgressListResponse.nextPageKey;
      }, err => {

      })
  }

  selectType(type) {
    this.showAll = type.srcElement.value == 1 ? true : false;
    this.showAll ? this.showAllList() : this.getProgressList();
  }

  showAllList() {
    this.ProgressService.getAllProgressList(this.nextPageKey).subscribe(res => {
      let arr = res.data;
      this.progressList = this.progressList.concat(arr);
      this.nextPageKey = res.nextPageKey;
    })
  }

  private getProgressList(): void {

    const data = this.route.snapshot.data;

    this.ProgressListResponse = get(data, ['progress'], []);
    this.progressList = this.ProgressListResponse.data;
    this.nextPageKey = this.ProgressListResponse.nextPageKey;
    this.progressList = chain(this.progressList)
      .sortBy((item) => parseInt(item.date.split('-').join(''))).reverse().value();

    if (this.progressList.length === 0) {
      this.showAlert = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/progress/list/list.component.ts